'use client'

import { setContext } from 'apollo-link-context'

export default setContext((_, { headers }: any): any => {
	const requestHeaders: any = { ...headers }
	const token = sessionStorage.getItem('token')
	token && (requestHeaders.Authorization = `Bearer ${token}`)

	process.env.NODE_ENV === 'development' && (requestHeaders.test = true)
	return {
		headers: requestHeaders
	}
})
